(function () {
  'use strict';

  var PRODUCT_HANDLES = [
    'black-jasmine-non-padded-wirefree-knitted-cotton-bra',
    'black-forget-me-not-cotton-full-cup-non-padded-wirefree-bra-with-full-lycra-support',
    'violet-knitted-cross-over-cotton-bra-non-padded-wirefree-bra',
    'pink-lily-softest-low-cut-floral-embroidered-cotton-bra',
    'nylon-cross-non-padded-lacy-bra',
    'black-sage',
    'maroon-marvel-non-padded-wirefree-stretchable-bra-with-lacy-cups',
    'pink-clarkia-padded-non-wired-t-shirt-bra',
    'red-zinnia',
    'zephyr-padded-bra-and-panty-set'
  ];

  var productPromise;
  var unit = 'in';

  function byId(id) {
    return document.getElementById(id);
  }

  function shopRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function injectRuntimeStyles() {
    if (byId('ep-kalles-runtime-styles')) return;

    var style = document.createElement('style');
    style.id = 'ep-kalles-runtime-styles';
    style.textContent = [
      '.ep-prod-variant{width:100%;margin:0 0 8px;padding:9px 10px;border:1px solid #e4d8d9;border-radius:8px;background:#fff;color:#171717;font-size:12px}',
      '.ep-prod-btn{width:100%;border:0;cursor:pointer;font-family:inherit}',
      '.ep-prod-btn[disabled]{opacity:.65;cursor:wait}',
      '.ep-prod-details{display:block;text-align:center;margin-top:8px;color:#6f6667;font-size:11px;text-decoration:underline;text-underline-offset:2px}',
      '.ep-cart-status{min-height:17px;margin-top:7px;text-align:center;font-size:11px;color:#7e2632}',
      '.ep-recs-loading{grid-column:1/-1;padding:24px;text-align:center;color:#6f6667;background:#fff;border:1px solid #e9e3e4;border-radius:14px}',
      '.hdt-rte .ep-recs-viewall,.hdt-rte .ep-recs-viewall:visited{color:#fff!important;background:#0b0b0b!important}',
      '.hdt-rte .ep-recs-viewall:hover,.hdt-rte .ep-recs-viewall:focus-visible{color:#fff!important;background:#b25260!important}',
      '@media (min-width:900px){.ep-recs-grid{grid-template-columns:repeat(3,minmax(0,1fr))!important}}',
      '@media (min-width:600px) and (max-width:899px){.ep-recs-grid{grid-template-columns:repeat(2,minmax(0,1fr))!important}}',
      '@media (max-width:599px){.ep-recs-grid{grid-template-columns:repeat(2,minmax(0,1fr))!important;gap:10px!important}.ep-prod-body{padding:10px!important}.ep-prod-name{font-size:11.5px!important}.ep-prod-btn{font-size:11px!important;padding:9px 5px!important}}'
    ].join('');
    document.head.appendChild(style);
  }

  function setUnit(nextUnit, button) {
    unit = nextUnit;

    document.querySelectorAll('.ep-tbtn').forEach(function (item) {
      item.classList.remove('ep-active');
      item.setAttribute('aria-pressed', 'false');
    });

    button.classList.add('ep-active');
    button.setAttribute('aria-pressed', 'true');

    byId('ep-u1').textContent = nextUnit;
    byId('ep-u2').textContent = nextUnit;
    byId('ep-underbust').placeholder = nextUnit === 'in' ? 'e.g. 30' : 'e.g. 76';
    byId('ep-bust').placeholder = nextUnit === 'in' ? 'e.g. 34' : 'e.g. 86';

    byId('ep-underbust').min = nextUnit === 'in' ? '20' : '50';
    byId('ep-underbust').max = nextUnit === 'in' ? '60' : '150';
    byId('ep-bust').min = nextUnit === 'in' ? '24' : '60';
    byId('ep-bust').max = nextUnit === 'in' ? '72' : '183';

    byId('ep-result').classList.remove('ep-show');
    byId('ep-error').classList.remove('ep-show');
    byId('ep-recs').classList.remove('ep-show');
  }

  function showError(message) {
    byId('ep-errtext').textContent = message;
    byId('ep-error').classList.add('ep-show');
  }

  function sizeAliases(band, cup) {
    var aliases = {
      DD: ['DD', 'E'],
      F: ['F', 'DDD']
    };

    return (aliases[cup] || [cup]).map(function (value) {
      return normaliseSize(String(band) + value);
    });
  }

  function normaliseSize(value) {
    return String(value || '')
      .toUpperCase()
      .replace(/\s+/g, '')
      .replace(/[()]/g, '')
      .replace(/\/(E|DDD)$/i, '');
  }

  function productSizeIndex(product) {
    var options = product.options || [];
    for (var index = 0; index < options.length; index += 1) {
      var name = typeof options[index] === 'string' ? options[index] : options[index].name;
      if (/size/i.test(name || '')) return index;
    }
    return 0;
  }

  function matchingVariants(product, band, cup) {
    var aliases = sizeAliases(band, cup);
    var index = productSizeIndex(product);

    return (product.variants || []).filter(function (variant) {
      var value = variant.options && variant.options[index] != null
        ? variant.options[index]
        : variant['option' + (index + 1)];
      return variant.available && aliases.indexOf(normaliseSize(value)) !== -1;
    });
  }

  function loadProducts() {
    if (productPromise) return productPromise;

    productPromise = Promise.all(PRODUCT_HANDLES.map(function (handle) {
      return fetch(shopRoot() + 'products/' + encodeURIComponent(handle) + '.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      }).then(function (response) {
        if (!response.ok) throw new Error('Product unavailable: ' + handle);
        return response.json();
      }).catch(function () {
        return null;
      });
    })).then(function (products) {
      return products.filter(Boolean);
    });

    return productPromise;
  }

  function money(cents) {
    return 'Rs.' + Math.round(Number(cents || 0) / 100).toLocaleString('en-PK');
  }

  function imageUrl(product, variant) {
    var image = variant.featured_image && (variant.featured_image.src || variant.featured_image);
    image = image || product.featured_image || (product.images && product.images[0]) || '';
    if (image.indexOf('//') === 0) return 'https:' + image;
    return image;
  }

  function variantLabel(product, variant) {
    var index = productSizeIndex(product);
    var values = (variant.options || []).filter(function (_value, optionIndex) {
      return optionIndex !== index;
    });
    return values.length ? values.join(' / ') : variant.title;
  }

  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function updateVariant(card, product, variants, select) {
    var variant = variants.filter(function (item) {
      return String(item.id) === String(select.value);
    })[0] || variants[0];

    var idInput = card.querySelector('input[name="id"]');
    idInput.value = String(variant.id);
    idInput.setAttribute('value', String(variant.id));
    card.querySelector('.ep-prod-price').textContent = money(variant.price);

    var image = card.querySelector('.ep-prod-img');
    var nextImage = imageUrl(product, variant);
    if (nextImage) image.src = nextImage;

    var details = card.querySelector('.ep-prod-details');
    details.href = shopRoot() + 'products/' + product.handle + '?variant=' + variant.id;
  }

  function addToCart(form, button, status) {
    var variantId = Number(form.querySelector('input[name="id"]').value);
    var cart = document.querySelector('[ref="hdt-cart"]');
    var sectionId = cart && cart.getAttribute('section-id');
    var payload = { items: [{ id: variantId, quantity: 1 }] };

    if (sectionId) {
      payload.sections = [sectionId];
      payload.sections_url = window.location.pathname;
    }

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Adding…';
    status.textContent = '';

    fetch(shopRoot() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || 'Could not add this item.');
        }
        return data;
      });
    }).then(function (cartData) {
      button.textContent = 'Added ✓';
      status.textContent = 'Added to your cart.';

      if (sectionId && cartData.sections && cartData.sections[sectionId]) {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: {},
            sourceId: String(variantId),
            cartData: cartData,
            actionAfterATC: 'open_cart_drawer',
            source: 'product-form-component',
            data: { itemCount: 1, sections: cartData.sections }
          }
        }));
      } else {
        document.dispatchEvent(new CustomEvent('cart:reload', { bubbles: true }));
      }
    }).catch(function (error) {
      button.textContent = 'Try Again';
      status.textContent = error.message || 'Could not add this item. Please try again.';
    }).finally(function () {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      window.setTimeout(function () {
        if (button.textContent === 'Added ✓') button.textContent = 'Add to Cart';
      }, 1800);
    });
  }

  function createProductCard(product, variants, size) {
    var firstVariant = variants[0];
    var card = element('div', 'ep-prod-card');
    var imageLink = element('a');
    var image = element('img', 'ep-prod-img');
    var body = element('div', 'ep-prod-body');
    var badge = element('div', 'ep-size-badge', 'Size ' + size);
    var name = element('div', 'ep-prod-name', product.title);
    var price = element('div', 'ep-prod-price', money(firstVariant.price));
    var select = element('select', 'ep-prod-variant');
    var form = element('form', 'ep-cart-form');
    var idInput = document.createElement('input');
    var addButton = element('button', 'ep-prod-btn', 'Add to Cart');
    var status = element('div', 'ep-cart-status');
    var details = element('a', 'ep-prod-details', 'View product');

    imageLink.href = shopRoot() + 'products/' + product.handle + '?variant=' + firstVariant.id;
    image.src = imageUrl(product, firstVariant);
    image.alt = product.title;
    image.loading = 'lazy';
    imageLink.appendChild(image);

    select.setAttribute('aria-label', 'Choose option for ' + product.title);
    variants.forEach(function (variant) {
      var option = document.createElement('option');
      option.value = variant.id;
      option.textContent = variantLabel(product, variant);
      select.appendChild(option);
    });

    idInput.type = 'hidden';
    idInput.name = 'id';
    idInput.value = String(firstVariant.id);
    idInput.setAttribute('value', String(firstVariant.id));
    addButton.type = 'submit';
    addButton.name = 'add';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    details.href = imageLink.href;

    select.addEventListener('change', function () {
      updateVariant(card, product, variants, select);
    });
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      addToCart(form, addButton, status);
    });

    form.appendChild(idInput);
    form.appendChild(addButton);
    body.appendChild(badge);
    body.appendChild(name);
    body.appendChild(price);
    if (variants.length > 1) body.appendChild(select);
    body.appendChild(form);
    body.appendChild(status);
    body.appendChild(details);
    card.appendChild(imageLink);
    card.appendChild(body);

    return card;
  }

  function showRecommendations(band, cup) {
    var recs = byId('ep-recs');
    var grid = byId('ep-recs-grid');
    var none = byId('ep-recs-none');
    var label = byId('ep-recs-label');
    var subtitle = byId('ep-recs-sub');
    var viewAll = byId('ep-recs-viewall');
    var noneLink = byId('ep-recs-none-link');
    var size = String(band) + cup;
    var filterUrl = shopRoot() + 'collections/all-bras?filter.v.option.size=' + encodeURIComponent(size);

    label.textContent = 'Products Available in Size ' + size;
    subtitle.textContent = 'Checking current sizes and stock…';
    viewAll.href = filterUrl;
    noneLink.href = filterUrl;
    grid.innerHTML = '';
    grid.appendChild(element('div', 'ep-recs-loading', 'Finding products available in your size…'));
    none.classList.remove('ep-show');
    recs.classList.add('ep-show');

    return loadProducts().then(function (products) {
      var matches = products.map(function (product) {
        return { product: product, variants: matchingVariants(product, band, cup) };
      }).filter(function (match) {
        return match.variants.length > 0;
      });

      grid.innerHTML = '';
      subtitle.textContent = matches.length + (matches.length === 1 ? ' style found in stock' : ' styles found in stock');

      if (!matches.length) {
        none.classList.add('ep-show');
      } else {
        matches.slice(0, 8).forEach(function (match) {
          grid.appendChild(createProductCard(match.product, match.variants, size));
        });
      }

      window.setTimeout(function () {
        recs.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }, 100);
    }).catch(function () {
      grid.innerHTML = '';
      subtitle.textContent = 'Products could not be loaded right now.';
      none.classList.add('ep-show');
    });
  }

  function calculate() {
    var error = byId('ep-error');
    var result = byId('ep-result');
    var underbust = parseFloat(byId('ep-underbust').value);
    var bust = parseFloat(byId('ep-bust').value);
    var method = byId('ep-method').value;
    var cups = ['AA', 'A', 'B', 'C', 'D', 'DD', 'F', 'G', 'H', 'HH'];

    error.classList.remove('ep-show');
    result.classList.remove('ep-show');
    byId('ep-recs').classList.remove('ep-show');

    if (!underbust || !bust || isNaN(underbust) || isNaN(bust)) {
      showError('Please enter both measurements.');
      return;
    }

    var underbustIn = unit === 'cm' ? underbust / 2.54 : underbust;
    var bustIn = unit === 'cm' ? bust / 2.54 : bust;

    if (underbustIn < 20 || underbustIn > 60) {
      showError('Underbust seems off. Try between 20–60 inches (50–150 cm).');
      return;
    }
    if (bustIn < underbustIn) {
      showError('Bust must be larger than underbust. Please re-check.');
      return;
    }

    var band;
    if (method === 'traditional') {
      var rounded = Math.round(underbustIn);
      band = rounded % 2 === 0 ? rounded + 4 : rounded + 5;
    } else {
      band = Math.round(underbustIn / 2) * 2;
      if (band < 28) band = 28;
    }

    var difference = bustIn - band;
    var cupIndex = Math.round(difference);
    if (cupIndex < 0) cupIndex = 0;
    if (cupIndex >= cups.length) cupIndex = cups.length - 1;

    var cup = cups[cupIndex];
    var displayDifference = unit === 'cm'
      ? (difference * 2.54).toFixed(1) + ' cm'
      : difference.toFixed(1) + '"';
    var tips = {
      AA: 'Try lightweight bralettes or soft-cup styles.',
      A: 'Lightly padded styles and balconettes will suit you well.',
      B: 'Most styles are designed around B cup — you have the widest choice.',
      C: 'Full-coverage and balconette styles will give the best support.',
      D: 'Look for underwired styles with wide-set straps for extra lift.',
      DD: 'Prioritize structured, underwired styles with padded straps.',
      F: 'Full-cup and minimiser bras provide the best support at this size.',
      G: 'Look for bras with side-support panels and wide cushioned straps.',
      H: 'Specialist full-bust styles with 3-part cups are best for you.',
      HH: 'Look for specialist fuller-bust brands with 4+ hook-and-eye fastenings.'
    };

    byId('ep-rs').innerHTML = String(band) + '<span>' + cup + '</span>';
    byId('ep-rd').textContent = 'Band ' + band + ' · Cup ' + cup + ' · Difference ' + displayDifference;
    byId('ep-dband').textContent = band;
    byId('ep-dcup').textContent = cup;
    byId('ep-ddiff').textContent = displayDifference;
    byId('ep-rtip').textContent = (tips[cup] || 'Try the size and see how it feels.') +
      ' Sister sizes: ' + (band - 2) + (cups[cupIndex + 1] || cup) +
      ' · ' + band + cup +
      ' · ' + (band + 2) + (cups[Math.max(0, cupIndex - 1)] || cup);

    document.querySelectorAll('.ep-hr').forEach(function (row) {
      row.classList.remove('ep-hr');
    });
    document.querySelectorAll('#ep-chart tbody tr').forEach(function (row) {
      if (row.cells[0].textContent.toLowerCase().indexOf(cup.toLowerCase()) !== -1) {
        row.classList.add('ep-hr');
      }
    });

    result.classList.add('ep-show');
    showRecommendations(band, cup);
  }

  function initCalculator() {
    var page = document.querySelector('.ep-page');
    if (!page || page.getAttribute('data-ep-kalles-ready') === 'true') return;
    page.setAttribute('data-ep-kalles-ready', 'true');
    injectRuntimeStyles();

    var unitButtons = page.querySelectorAll('.ep-tbtn');
    if (unitButtons[0]) {
      unitButtons[0].type = 'button';
      unitButtons[0].addEventListener('click', function () {
        setUnit('in', unitButtons[0]);
      });
    }
    if (unitButtons[1]) {
      unitButtons[1].type = 'button';
      unitButtons[1].addEventListener('click', function () {
        setUnit('cm', unitButtons[1]);
      });
    }

    var calculateButton = page.querySelector('.ep-btn');
    if (calculateButton) {
      calculateButton.type = 'button';
      calculateButton.addEventListener('click', calculate);
    }

    page.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' && (event.target === byId('ep-underbust') || event.target === byId('ep-bust'))) {
        event.preventDefault();
        calculate();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCalculator);
  } else {
    initCalculator();
  }

  document.addEventListener('shopify:section:load', initCalculator);
})();
